import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { Reveal } from "./motion/Reveal";
import { BUSINESS } from "../data/content";

export const CTASection = () => (
  <section data-testid="cta-section" className="relative overflow-hidden bg-ink py-24 text-white sm:py-32">
    <div
      className="pointer-events-none absolute inset-0"
    >
      <div className="absolute -left-32 top-0 h-[480px] w-[480px] rounded-full bg-brand/20 blur-[140px]" />
      <div className="absolute -right-24 bottom-0 h-[420px] w-[420px] rounded-full bg-brand/10 blur-[130px]" />
    </div>
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand">
          Ready when you are
        </p>
        <h2 className="mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
          Get more calls. Get more customers. <span className="text-brand">Grow.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-lg text-white/70">
          Tell us about your business and we'll show you exactly how a premium website
          and smart automation can help you grow — free, no pressure.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link
            to="/contact"
            data-testid="cta-quote-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-4 font-bold text-ink transition-transform duration-300 hover:-translate-y-0.5 hover:bg-brand-dark hover:text-white"
          >
            Request a Free Quote
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <a
            href={BUSINESS.phoneHref}
            data-testid="cta-call-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-4 font-bold text-white transition-colors hover:bg-white/10"
          >
            <Phone className="h-4 w-4 text-brand" /> Call {BUSINESS.phone}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
